var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[(_vm.props.hasAttachments)?_c('v-icon',[_vm._v(" mdi-paperclip ")]):_c('span',[_vm._v(" "+_vm._s(_vm.parent.$tc("no", 1))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }